import { Box, Collapse, Grid } from '@material-ui/core';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { AirportField } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Flight/components/FlightForm/components/AirportField';
import { Font } from '@/components/shared/components/Font';
import { CheckboxFormField } from '@/components/shared/components/NewContextForms/CheckboxFormField';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';
import { useConfigContext } from '@/contexts/ConfigContext/ConfigContext';

export const FlightDetailsForm = () => {
  const {
    state: { dictionaryValues },
  } = useConfigContext();
  const { watch, setValue } = useFormContext();

  const isRoundTrip = watch('item.isRoundTrip');
  const departureDate = watch('item.departureDate');
  const departureAirport = watch('item.departureAirport');
  const destinationAirport = watch('item.destinationAirport');

  useEffect(() => {
    setValue('item.returnDate', null);
    setValue('item.returnReference', '');
  }, [isRoundTrip]);

  return (
    <>
      <Font variant="h4" color="textPrimary">
        <Text strong tId={'FLIGHT_DETAILS'} />
      </Font>
      <Box mt={2} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <AirportField
            name={'item.departureAirport'}
            exclude={destinationAirport}
            label={'DEPARTURE_AIRPORT'}
            placeholder={'BCN'}
            fieldVariant={FieldVariant.form}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AirportField
            name={'item.destinationAirport'}
            exclude={departureAirport}
            label={'DESTINATION_AIRPORT'}
            placeholder={'LIS'}
            fieldVariant={FieldVariant.form}
          />
        </Grid>
      </Grid>
      <Box mt={3}>
        <Box my={2}>
          <Font variant={'h5'}>
            <Text tId={isRoundTrip ? 'FLIGHT_OUTBOUND' : 'FLIGHT_ONE_WAY'} />
          </Font>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <DateFormField name={'item.departureDate'} label={'DATE'} fieldVariant={FieldVariant.form} disablePast />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextFormField
              name={'item.reference'}
              label={'FLIGHT_REFERENCE'}
              placeholder={dictionaryValues['FLIGHT_REFERENCE_PLACEHOLDER']}
              fieldVariant={FieldVariant.form}
            />
          </Grid>
        </Grid>
      </Box>
      <Collapse in={isRoundTrip}>
        <Box mt={3}>
          <Box mb={2}>
            <Font variant={'h5'}>
              <Text tId={'FLIGHT_INBOUND'} />
            </Font>
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <DateFormField
                name={'item.returnDate'}
                label={'DATE'}
                fieldVariant={FieldVariant.form}
                minDate={
                  departureDate
                    ? new Date(new Date(departureDate).setDate(new Date(departureDate).getDate() + 1))
                    : new Date()
                }
                disablePast
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextFormField
                name={'item.returnReference'}
                label={'FLIGHT_REFERENCE'}
                placeholder={dictionaryValues['FLIGHT_REFERENCE_PLACEHOLDER']}
                fieldVariant={FieldVariant.form}
              />
            </Grid>
          </Grid>
        </Box>
      </Collapse>
      <Grid container spacing={2} style={{ paddingTop: 12 }}>
        <Grid item xs={12}>
          <Box mt={2} mb={1}>
            <CheckboxFormField
              color={'secondary'}
              name={'item.isRoundTrip'}
              label={'IS_ROUND_TRIP'}
              fieldVariant={FieldVariant.form}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
